module.exports = __webpack_public_path__ + "assets/img/kehu.9c186609.png";